import { Helmet } from "react-helmet-async";

interface SEOProps {
    title?: string;
    description?: string;
}

const DEFAULT_TITLE = "Denny | Savour the Flavour";

const DEFAULT_DESCRIPTION =
    "Discover delicious recipes, cooking inspiration, products and more from Denny. Savour the flavour with ideas for every meal and every occasion.";

export default function SEO({
                                title = DEFAULT_TITLE,
                                description = DEFAULT_DESCRIPTION,
                            }: SEOProps) {
    return (
        <Helmet>
            <title>{title}</title>

            <meta
                name="description"
                content={description}
            />
        </Helmet>
    );
}
